import debug from 'debug';

const log = debug('Feature');

class Feature {
	static hasFeature(feature) {
		const features = document.body.getAttribute('data-features').split('|');

		if (features.length === 0) return false;

		if (features.includes(feature)) return true;

		return false;
	}

	/**
	 * @returns {boolean}
	 */
	static isEnabled(feature) {
		return this.hasFeature(feature);
	}
}

export default Feature;
